import * as React from "react";

import { AllocationConstraintDto } from "core/backend/data";
import { MultiSelectItem } from "components/multiselect";
import TDatetime from "components/TDatetime";

interface OwnProps {
    dto: AllocationConstraintDto;
    left: number;
}

const Row = ({ dto, left }: OwnProps) =>
    <tr>
        <TDatetime rowSpan={1} date={new Date(dto.dateTimeUtc)} left={left} />
        <td>{dto.totalLoad}</td>
        <td>{dto.totalNonDisp}</td>
        <td>{dto.minDispNeeded}</td>
        <td>{dto.allocationConstraintImport === 12000 ? "N/A*" : dto.allocationConstraintImport}</td>
        <td>{dto.allocationConstraintExport === 12000 ? "N/A*" : dto.allocationConstraintExport}</td>
    </tr>;

export default Row;